// Firebase client bootstrap — separate from backend Firebase Admin SDK.
// Sessions are NOT shared across apps (web-backoffice vs web-intermediari) —
// see project_frontend_decisions.md "Auth multi-app".

import { type FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { type Auth, getAuth } from 'firebase/auth';
import { env, firebaseClientConfigured } from '@/lib/env';

let _app: FirebaseApp | null = null;
let _auth: Auth | null = null;

export function getFirebaseApp(): FirebaseApp | null {
  if (!firebaseClientConfigured) return null;
  if (_app) return _app;
  const existing = getApps()[0];
  _app = existing ?? initializeApp({
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: env.VITE_FIREBASE_PROJECT_ID,
    appId: env.VITE_FIREBASE_APP_ID,
  });
  return _app;
}

export function getFirebaseAuth(): Auth | null {
  if (_auth) return _auth;
  const app = getFirebaseApp();
  if (!app) return null;
  _auth = getAuth(app);
  return _auth;
}

export const isEmulatorMode = env.VITE_FIREBASE_USE_EMULATOR === '1';
